"use strict";
/* This file is autogenerated */
Object.defineProperty(exports, "__esModule", { value: true });
exports.redRgb = exports.redLightRgb = exports.redLight = exports.redHoverSolidRgb = exports.redHoverSolid = exports.redHoverOpaque = exports.redHover = exports.red50Opaque = exports.red50 = exports.red = exports.purpleTextLabelRgb = exports.purpleTextLabel = exports.purpleRgb = exports.purpleLightRgb = exports.purpleLight = exports.purple50Opaque = exports.purple50 = exports.purple = exports.greenTextLabelRgb = exports.greenTextLabel = exports.greenRgb = exports.greenLightRgb = exports.greenLight = exports.green50Opaque = exports.green50 = exports.green = exports.grayShadowOpaque = exports.grayShadow = exports.grayMediumOpaque = exports.grayMedium = exports.grayLightOpaque = exports.grayLight = exports.grayAiryOpaque = exports.grayAiry = exports.darknessOpaque = exports.darkness = exports.blueShadowRgb = exports.blueShadow = exports.blueRgb = exports.blueLightRgb = exports.blueLight = exports.blueHoverRgb = exports.blueHover = exports.blue50Opaque = exports.blue50 = exports.blue = exports.blackRgb = exports.black = exports.backgroundRgb = exports.background = void 0;
exports.yellowTextLabelRgb = exports.yellowTextLabel = exports.yellowRgb = exports.yellowLightRgb = exports.yellowLight = exports.yellow50Opaque = exports.yellow50 = exports.yellow = exports.whiteRgb = exports.white = exports.wcagRedRgb = exports.wcagRed = exports.wcagNonTextRgb = exports.wcagNonText = exports.wcagGrayRgb = exports.wcagGray = void 0;
exports.background = '#F8F8FB';
exports.backgroundRgb = 'rgb(248, 248, 251)';
exports.black = '#1D1D1D';
exports.blackRgb = 'rgb(29, 29, 29)';
exports.blue = '#5A3DE6';
exports.blue50 = 'rgba(90, 61, 230, 0.5)';
exports.blue50Opaque = '#AD9EF3';
exports.blueHover = '#4D34C6';
exports.blueHoverRgb = 'rgb(77, 52, 198)';
exports.blueLight = '#EBE8FC';
exports.blueLightRgb = 'rgb(235, 232, 252)';
exports.blueRgb = 'rgb(90, 61, 230)';
exports.blueShadow = '#3B2D81';
exports.blueShadowRgb = 'rgb(59, 45, 129)';
exports.darkness = 'rgba(29, 29, 29, 0.7)';
exports.darknessOpaque = '#616161';
exports.grayAiry = 'rgba(47, 36, 105, 0.04)';
exports.grayAiryOpaque = '#F7F6F9';
exports.grayLight = 'rgba(47, 36, 105, 0.08)';
exports.grayLightOpaque = '#EEEDF3';
exports.grayMedium = 'rgba(47, 36, 105, 0.16)';
exports.grayMediumOpaque = '#DEDCE7';
exports.grayShadow = 'rgba(47, 36, 105, 0.24)';
exports.grayShadowOpaque = '#CDCADB';
exports.green = '#00B683';
exports.green50 = 'rgba(0, 182, 131, 0.5)';
exports.green50Opaque = '#80DBC1';
exports.greenLight = '#D6F3EB';
exports.greenLightRgb = 'rgb(214, 243, 235)';
exports.greenRgb = 'rgb(0, 182, 131)';
exports.greenTextLabel = '#007958';
exports.greenTextLabelRgb = 'rgb(0, 121, 88)';
exports.purple = '#B039D3';
exports.purple50 = 'rgba(176, 57, 211, 0.5)';
exports.purple50Opaque = '#D89CE9';
exports.purpleLight = '#F6E7FA';
exports.purpleLightRgb = 'rgb(246, 231, 250)';
exports.purpleRgb = 'rgb(176, 57, 211)';
exports.purpleTextLabel = '#A335C3';
exports.purpleTextLabelRgb = 'rgb(163, 53, 195)';
exports.red = '#F46147';
exports.red50 = 'rgba(244, 97, 71, 0.5)';
exports.red50Opaque = '#FAB0A3';
exports.redHover = 'rgba(209, 21, 21, 0.08)';
exports.redHoverOpaque = '#FBECEC';
exports.redHoverSolid = '#FDF3F3';
exports.redHoverSolidRgb = 'rgb(253, 243, 243)';
exports.redLight = '#FDE6E2';
exports.redLightRgb = 'rgb(253, 230, 226)';
exports.redRgb = 'rgb(244, 97, 71)';
exports.wcagGray = '#72707E';
exports.wcagGrayRgb = 'rgb(114, 112, 126)';
exports.wcagNonText = '#9591AA';
exports.wcagNonTextRgb = 'rgb(149, 145, 170)';
exports.wcagRed = '#D11515';
exports.wcagRedRgb = 'rgb(209, 21, 21)';
exports.white = '#FFFFFF';
exports.whiteRgb = 'rgb(255, 255, 255)';
exports.yellow = '#FFB938';
exports.yellow50 = 'rgba(255, 185, 56, 0.5)';
exports.yellow50Opaque = '#FFDC9C';
exports.yellowLight = '#FFEECF';
exports.yellowLightRgb = 'rgb(255, 238, 207)';
exports.yellowRgb = 'rgb(255, 185, 56)';
exports.yellowTextLabel = '#8B651E';
exports.yellowTextLabelRgb = 'rgb(139, 101, 30)';
//# sourceMappingURL=colors.js.map